import React from 'react';
import PropTypes from 'prop-types';

import {IconoirCustomLabelSolid} from '@ey-xd/motif-icon';

import OutputText from '@ey/canvascoreservices/OutputText';
import Icon from '@ey/canvascoreservices/Icon';

import StyledTagLabel from './StyledTagLabel';

const variants = ['blue', 'red', 'orange', 'teal', 'purple', 'green'];

const TagLabel = ({variant = variants[0], text = '', className = null}) => {
	const props = {
		$color: variant
	};

	if (className) props.className = className;

	return (
		<StyledTagLabel {...props}>
			<Icon src={IconoirCustomLabelSolid} size={20} />
			<OutputText ellipsis title={text} useTypography={false}>
				{text}
			</OutputText>
		</StyledTagLabel>
	);
};

TagLabel.propTypes = {
	variant: PropTypes.oneOf(variants),
	text: PropTypes.string.isRequired,
	className: PropTypes.string
};

export default TagLabel;
